import { configureStore } from "@reduxjs/toolkit";

import { goalsReducer } from "../features/goals";

const store = configureStore({
  reducer: {
    goalsState: goalsReducer,
  },
});

export default store;
